import { adminApi } from "../admin/api";

export const studiovideoApi = {
  async transcribe(audioBlob, { filename = "audio.wav" } = {}) {
    const form = new FormData();
    form.append("file", audioBlob, filename);
    const { data } = await adminApi.post("/studiovideo/transcribe", form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 180000,
    });
    return data; // { text, language, duration, segments }
  },
  async saveProject(payload) {
    const { data } = await adminApi.post("/studiovideo/projects", payload, { timeout: 30000 });
    return data;
  },
  async listProjects({ limit = 24, skip = 0 } = {}) {
    const { data } = await adminApi.get("/studiovideo/projects", { params: { limit, skip } });
    return data;
  },
  async getProject(id) {
    const { data } = await adminApi.get(`/studiovideo/projects/${id}`);
    return data;
  },
  async deleteProject(id) {
    await adminApi.delete(`/studiovideo/projects/${id}`);
  },
};
